<template>
  <section>
    <!-- //<Header :user="user" /> -->

    <main
      class="main animated fadeIn faster"
      :class="{ 'expand-main': isMenuCollapse }"
    >
      <!-- Profile Card -->
      <div class="d-flex jusitify-content-center">
        <div class="col-12 p-4">
          <div class="card mt-3 ">
            <div class="card-body px-3">
              <div class="row">
                <!-- Profile Info Section -->
                <div class="col-12">
                  <div class="d-flex row" style="position:relative;">
                    <div
                      class="w-100 bg-primary"
                      style="height:80px"
                    ></div>
                    <div class="col-12" style="height:50px"></div>
                    <img
                      class="ml-4 rounded-circle shadow"
                      height="80px"
                      :src="businessContact.business_contact.photo
 ? businessContact.business_contact.photo : getImageBilling()"
                      style="position:absolute;"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <ul class="list-unstyled">
                    <li>
                      <strong>{{ $t("lang.businessContactInfo.name") }}:</strong>
                      {{ businessContact.business_contact.name }}
                    </li>
                    <li>
                      <strong>{{ $t("lang.businessContactInfo.job") }}:</strong>
                      {{ businessContact.business_contact.job }}
                    </li>
                    <li>
                      <strong>{{ $t("lang.businessContactInfo.email") }}:</strong>
                      {{ businessContact.business_contact.email }}
                    </li>
                    <li>
                      <strong>{{ $t("lang.businessContactInfo.company") }}:</strong>
                      {{ businessContact.business_contact.enterprise }}
                    </li>
                    <li>
                      <strong>{{ $t("lang.businessContactInfo.phone") }}:</strong>
                      {{ businessContact.business_contact.phone }}
                    </li>
                    <li>
                      <strong>{{ $t("lang.businessContactInfo.name") }}:</strong>
                      {{ businessContact.business_contact.snippet }}
                    </li>
                  </ul>
                </div>

                <!-- Additional Information Section -->
                <div class="col-md-9">
                  <div class="row">
                    <div class="col-md-4">
                      <ul class="list-unstyled">
                        <li>
                          <strong>{{ $t("lang.businessContactInfo.companysize") }}</strong>
                          {{
                            businessContact.business_enterprise.salariesmin
                          }}-{{ businessContact.business_enterprise.salaries }}
                        </li>
                        <li>
                          <strong>{{ $t("lang.businessContactInfo.country") }}:</strong>
                          {{ businessContact.business_enterprise.country }}
                        </li>
                        <li>
                          <strong>{{ $t("lang.businessContactInfo.address") }}:</strong
                          >{{ businessContact.business_enterprise.address }}
                        </li>
                        <li>
                          <strong>{{ $t("lang.businessContactInfo.postalcode") }}:</strong>
                          {{ businessContact.business_enterprise.postal_code }}
                        </li>
                        <li>
                          <strong>{{ $t("lang.businessContactInfo.address") }}:</strong>
                          {{ businessContact.business_enterprise.address }}
                        </li>
                        <li>
                          <strong>{{ $t("lang.businessContactInfo.companycity") }}:</strong>
                          {{ businessContact.business_enterprise.city }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-4">
                      <ul class="list-unstyled">
                        <li>
                          <strong>{{ $t("lang.businessContactInfo.creationdate") }}:</strong>
                          {{ businessContact.business_contact.creation_date }}
                        </li>
                        <li>
                          <strong>{{ $t("lang.businessContactInfo.lastupdate") }}:</strong> {{ businessContact.business_contact.updated }}
                        </li>

                        <li>
                          <strong>{{ $t("lang.businessContactInfo.lastemaildate") }}:</strong> {{ businessContact.counts.last_scheduled_sent_date
}}
                        </li>

                        <li>
                          <strong>{{ $t("lang.businessContactInfo.totalemailsent") }} :</strong>
                          {{ businessContact.counts.total_sent }}
                        </li>
                        <li>
                          <strong class="mr-2"
                            >{{ $t("lang.businessContactInfo.totalmanualresponse") }}:</strong
                          >{{ businessContact.email_response.total_er }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-4">
                      <ul class="list-unstyled">
                        <li>
                          <strong class="mr-3"
                            >{{ $t("lang.businessContactInfo.lastcalendarclick") }}:</strong
                          >
                          {{
                            businessContact.link_activity.last_click_calendar
                          }}
                        </li>
                        <li>
                          <strong>{{ $t("lang.businessContactInfo.lastmeetingschedule") }}:</strong
                          >{{ businessContact.link_event.last_meeting_saved }}
                        </li>
                        <li>
                          <strong>{{ $t("lang.businessContactInfo.totalmeetingschedule") }}:</strong>
                          {{ businessContact.link_event.total_meetings }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Action Table -->
              <div class="table-responsive mt-4">
                <table class=" w-100 table table-hover bg-white">
                  <thead class="">
                    <tr>
                      <th>Action</th>
                      <th>Date</th>
                      <th>Email</th>
                      <th>Client</th>
                      <th>{{ $t("lang.label.order") }}</th>
                      <th>Opportunity</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="bc in businessContact.total_stats">
                      <td>
                        <img
                          v-if="bc.bc_action == 'Email step 1'"
                          width="20"
                          height="20"
                          src="@/assets/images/icons_png/email_step1.png"
                          alt=""
                        />
                        <img
                          v-if="bc.bc_action == 'Email follow-up'"
                          width="20"
                          height="20"
                          src="@/assets/images/icons_png/email_follow_up.png"
                          alt=""
                        />
                        <img
                          v-if="bc.bc_action == 'Bounce'"
                          width="20"
                          height="20"
                          src="@/assets/images/icons_png/bounce.png"
                          alt=""
                        />
                        <img
                          v-if="bc.bc_action == 'opt_out'"
                          width="20"
                          height="20"
                          src="@/assets/images/icons_png/bounce.png"
                          alt=""
                        />
                        <img
                          v-if="bc.bc_action == 'meeting'"
                          width="20"
                          height="20"
                          src="@/assets/images/icons_png/meeting.png"
                          alt=""
                        />
                        <img
                          v-if="bc.bc_action == 'Manual answer'"
                          width="20"
                          height="20"
                          src="@/assets/images/icons_png/manual_asnwer.png"
                          alt=""
                        />
                        <img
                          v-if="bc.bc_action == 'Automatic answer'"
                          width="20"
                          height="20"
                          src="@/assets/images/icons_png/robot.png"
                          alt=""
                        />
                        <img
                          v-if="bc.bc_action == 'click'"
                          width="20"
                          height="20"
                          src="@/assets/images/icons_png/click.png"
                          alt=""
                        />
                            <img
                          v-if="bc.bc_action == 'mailing black'"
                          width="20"
                          height="20"
                          src="@/assets/images/icons_png/email_block.png"
                          alt=""
                        />

                        {{ bc.bc_action }}
                      </td>
                      <td>{{ bc.scheduled_date }}</td>
                      <td>{{ bc.email }}</td>
                      <td class="text-primary">
                        <a :href="'/clients/' + bc.client_id">{{ bc.name }}</a>
                      </td>
                      <td class="text-primary">
                        <a target="_blank" :href="'/orders/' + bc.target_id">{{
                          bc.target_name
                        }}</a>
                      </td>
                      <td class="text-primary">
                        <a target="_blank" :href="'/opportunities/' + bc.link_id">{{
                          bc.opportunity_name
                        }}</a>
                      </td>
                    </tr>
                    <!-- Repeat other rows as needed -->
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>
<script>
import { businessContactsService } from "@/_services";
export default {
  data() {
    return {
      businessContact: []
    };
  },
  created() {
    if (this.$route.params.id !== "undefined") {
      console.log(this.$route.params.id);
      this.getBusinessContact(this.$route.params.id);
    }
  },
  methods: {
    getBusinessContact(id) {
      businessContactsService.getBusinessInfo(id).then(res => {
        console.log(res);
        this.businessContact = res;
      });
    },
      getImageBilling() {
      return require("@/assets/images/emptyperson.png");
    },
  }
};
</script>
